export default __webpack_public_path__ + "static/media/MISTRZ_TECHNOLOGII.30089225.png";